<!-- start page title -->
<div class="row h-40px">
  <div class="col-12">
    <div class="page-title-box d-flex align-items-center justify-content-between">
      <h4 class="mb-0">{{title}}</h4>
    </div>
  </div>
</div>
<!-- end page title -->
